import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "react-bootstrap";
import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";
import { deactivateAccount, reactivateAccount } from "api";
import { toast } from "react-toastify";

interface IDialogProps {
  header: string;
  title: string;
  warning: string;
  email: string;
  action: string;
  success: string;
}

interface IConfirmationModalProps {
  isShowing: boolean;
  close: () => void;
  email: string;
  dialogMessage: IDialogProps;
  setIsUpdateData: Function;
}

function ConfirmationModal({ isShowing, close, dialogMessage, setIsUpdateData }: IConfirmationModalProps) {
  const handleDeactivateAccount = (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const executefunc = // @TODO: Is this supposed to be unused?
      dialogMessage.header === "Deactivate user"
        ? deactivateAccount(dialogMessage.email)
        : reactivateAccount(dialogMessage.email)
            .then((res) => {
              if (res.status) {
                toast(dialogMessage.success, { type: "success" });
              }
            })
            .catch((error) => toast(error, { type: "error" }));
    close();
    setIsUpdateData(true);
  };

  return (
    <div>
      <Dialog show={isShowing} title={dialogMessage.header} onHide={close}>
        <form>
          <Row className="mb-3">
            <Col className="pb-3">
              <div>
                <FormattedMessage
                  id="settings.titleMesssage"
                  defaultMessage="{title}"
                  values={{ title: dialogMessage.title }}
                />
              </div>
              <div>
                <FormattedMessage
                  id="settings.warningMesssage"
                  defaultMessage="{warning}"
                  values={{ warning: dialogMessage.warning }}
                />
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <div className="d-block border-grey border-top w-100" />
            </Col>
          </Row>
          <Button onClick={handleDeactivateAccount} className="ml-auto" variant="success" type="submit">
            <FormattedMessage
              id="settings.actionButton"
              defaultMessage="{action}"
              values={{ action: dialogMessage.action }}
            />
          </Button>
        </form>
      </Dialog>
    </div>
  );
}

export default ConfirmationModal;
